'use strict';

angular.module('nv.support-attendance-form', ['nv.shared.services', 'nv.shared.modals']);
